import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionButtons}
    apiSuffix="salesteam/regions" 
    sortable={["Created On"]}
  />;
};

const regionFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getInputField("Name", { name: "name",   required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Location", "metadata/list-locations", { name: "locationId", required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Is Active", { name: "isActive", field: "checkbox", inline: true, value: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description", { name: "description" })]);
  return myForm;
};

const AddRegionForm = () => {
  const myForm = regionFormFields(new BCFormController({}, { submitSuffix: "salesteam/regions", blankWidth: 4 })); 
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions}  />);
};

const EditRegionForm = ({ id }) => {
  const deleteSuffix = "salesteam/regions";
  const [{ data = {}, isLoading, error }] = useFetchData(`salesteam/regions/${id}`);
  const myForm = regionFormFields(new BCFormController(data, { submitSuffix: "salesteam/region", clearSuffixesOnSubmit: [id], deleteSuffix, blankWidth: 4 })); 
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />;
};

const LmsSalesTeamRegion = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable/>}
    {isAdd && <AddRegionForm  />}
    {isEdit && <EditRegionForm id={id} />}
  </>);
};

export default LmsSalesTeamRegion;